import { Effect, EffectProperties, EffectFields } from '../../core/Effect';
import * as PostProcessing from '@react-three/postprocessing';
import { forwardRef } from 'react';
import * as THREE from 'three';
import { Field } from '@/types/core/Field';
import { BlendFunction } from 'postprocessing';

export interface ColorAverageEffectProperties extends EffectProperties {
  // ColorAverage doesn't have any specific properties beyond the common ones
}

// Create a reusable ColorAverage component that can be used in both preview and world
const ColorAverageComponent = forwardRef<any, { properties: ColorAverageEffectProperties; isPreview?: boolean }>((props, ref) => {

  const { properties, isPreview } = props;

  if (isPreview) {
    return null;
  }
  
  const { blendFunction } = properties;

  // Convert blendFunction string to number if it exists
  const blendFunctionValue = blendFunction ? 
    BlendFunction[blendFunction as keyof typeof BlendFunction] : 
    BlendFunction.NORMAL;

  return (
    <PostProcessing.ColorAverage
      blendFunction={blendFunctionValue}
    />
  );
});

export const ColorAverageEffectItem: Effect<ColorAverageEffectProperties> = {
  id: '',
  name: 'Color Average',
  type: 'effect',
  subtype: 'ColorAverage',
  icon: 'Effect',
  properties: {
    blendFunction: 'NORMAL',
  },
  fields: [
    ...EffectFields,
    {
      key: 'properties.blendFunction',
      type: 'select',
      label: 'Blend Function',
      default: 'NORMAL',
      options: [
        { value: 'NORMAL', label: 'Normal' },
        { value: 'ADD', label: 'Add' },
        { value: 'SUBTRACT', label: 'Subtract' },
        { value: 'MULTIPLY', label: 'Multiply' },
        { value: 'SCREEN', label: 'Screen' },
        { value: 'OVERLAY', label: 'Overlay' },
      ],
      panel: 'effect',
    }
  ],
  render: (properties: ColorAverageEffectProperties, isPreview: boolean, ref: React.RefObject<THREE.Object3D | null>) => {
    return <ColorAverageComponent properties={properties} isPreview={isPreview} ref={ref as any} />;
  }
}; 